import DesistedLayout from './desisted-layout';

const ThanksFeedbackPage = () => {
    return (
        <DesistedLayout />
    );
}

export default ThanksFeedbackPage;
